const HERO_HEADER_SIZE_CLASSES = {
    'xx-small': 'text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-3xl',
    'x-small': 'text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl',
    small: 'text-3xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl',
    medium: 'text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-6xl',
    large: 'text-3xl sm:text-4xl md:text-6xl lg:text-6xl xl:text-6xl',
};

const CENTER_HERO_HEADER_SIZE_CLASSES = {
    ...HERO_HEADER_SIZE_CLASSES,
    large: 'text-3xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-8xl',
};

const OVERFLOW_HERO_HEADER_SIZE_CLASSES = {
    ...HERO_HEADER_SIZE_CLASSES,
    large: 'text-3xl sm:text-4xl md:text-6xl lg:text-6xl xl:text-7xl',
};

const PAGE_HERO_HEADER_SIZE_CLASSES = {
    'xx-small': 'text-lg md:text-xl lg:text-2xl',
    'x-small': 'text-xl md:text-2xl lg:text-3xl',
    small: 'text-2xl md:text-4xl lg:text-4xl',
    medium: 'text-3xl md:text-4xl lg:text-5xl',
    large: 'text-3xl md:text-5xl lg:text-6xl',
};

function normalizeHeroHeaderSize(size) {
    const normalized = String(size || 'large')
        .trim()
        .toLowerCase();
    return Object.prototype.hasOwnProperty.call(
        HERO_HEADER_SIZE_CLASSES,
        normalized
    )
        ? normalized
        : 'large';
}

export function getHeroHeaderSizeClasses(size, variant = 'default') {
    const normalized = normalizeHeroHeaderSize(size);
    if (variant === 'center') {
        return CENTER_HERO_HEADER_SIZE_CLASSES[normalized];
    }
    if (variant === 'overflow') {
        return OVERFLOW_HERO_HEADER_SIZE_CLASSES[normalized];
    }
    if (variant === 'page') {
        return PAGE_HERO_HEADER_SIZE_CLASSES[normalized];
    }
    return HERO_HEADER_SIZE_CLASSES[normalized];
}
